import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TemplateModule } from '../template/template.module';
import { ContactDialogComponent } from './contact-dialog.component';
import { ContactTemplateComponent } from './contact-template/contact-template.component';
import { ContactTemplateModule } from './contact-template/contact-template.module';
import { ContactNavigationComponent } from './contact-navigation/contact-navigation.component';
import { TemplateSettingDialogService } from '../template-setting-dialog/template-setting-dialog.service';
@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        TemplateModule,
        ContactTemplateModule
    ],
    declarations: [
        ContactDialogComponent,
        ContactTemplateComponent,
        ContactNavigationComponent,
    ],
    providers: [
        TemplateSettingDialogService
    ],
    exports: [
        ContactDialogComponent,
    ]
})
export class ContactDialogModuleNew { }
